import { ConnectionsProfile, FullProfile } from '../../api/expert/types';

export const defaultProfile: FullProfile = {
    firstName: 'Bob',
    lastName: 'Pancakes',
    title: 'Dr',
    pronouns: 'They/Them',
    jobTitle: 'Clinical Psychologist',
    languages: ['eng', 'fra', 'kor'],
    headline: 'This is my headline',
    aboutMe: 'This is my about me section',
    location: 'london',
    professionalQualifications: ['PG Dip CBT', 'Bsc'],
    topSpecialisms: ['Anxiety', 'Depression', 'ADHD'],
    otherTopics: ['Bereavement', 'Relationships', 'Trauma and PTSD'],
    treatmentApproaches: ['Coginitive Behavioural Therapy', 'Mindfulness Based Interventions'],
    qualifications: [
        {
            name: 'Something something',
            organisation: 'British Psychological Society',
            startDate: '2011',
            endDate: null,
        },
    ],
    experience: [
        {
            name: 'Clinical Psychologist/Clinical Director',
            organisation: 'HelloSelf',
            startDate: '2021',
            endDate: 'Present',
        },
        {
            name: 'Therapist Assistance',
            organisation: 'London Family Service',
            startDate: '2006',
            endDate: '2011',
        },
    ],
    education: [
        {
            name: 'Msc Psychology',
            organisation: 'Kingston University',
            startDate: '2008',
            endDate: '2014',
            iconUrl:
                'https://d68b3152cf5d08c2f050-97c828cc9502c69ac5af7576c62d48d6.ssl.cf3.rackcdn.com/includes/img/site-cms/Kingston_University_London_logo_320-desktop-black.png',
        },
    ],
    isPublic: true,
};

export const defaultConnectionsProfile: ConnectionsProfile = {
    expertId: '1',
    externalId: 'a',
    firstName: defaultProfile.firstName,
    lastName: defaultProfile.lastName,
    title: defaultProfile.title,
    jobTitle: defaultProfile.jobTitle,
    presentations: [
        { name: 'Anxiety', id: 1, isSpecialism: true },
        { name: 'Anger Issues', id: 102, isSpecialism: false },
    ],
    isPublic: defaultProfile.isPublic,
    modalities: [{ id: 45, name: 'CBT' }],
    insurers: [{ organisationId: 1, displayName: 'Axa' }],
    languages: ['eng', 'dan'],
    userType: 'partner',
    isConnected: true,
    isFavourite: true,
};

export const createTestConnectionsProfile = (profile?: Partial<ConnectionsProfile>) =>
    ({
        ...defaultConnectionsProfile,
        ...profile,
    } as ConnectionsProfile);
